import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { KindAllNodeCascader as LocalKindAllNodeCascader } from '../../components/Kind/AllNode/Cascader'

export const KindAllNodeCascader = connect(
  LocalKindAllNodeCascader,
  mapReadPretty(LocalKindAllNodeCascader, {
    disabled: true
  })
)
